import React from 'react';
import './ShopBoxes.scss';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { urlFormatter, getQueries } from '../../../util';
import { withRouter } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import shopboxPlaceholder from 'assets/img/shopbox_placeholder.gif';

import * as constants from '../../../constants';
let forceRedirect = false;

const ShopBoxes = (props) => {
  const [redirect, updateRedirect] = React.useState(null);
  const { links, urlState, location, history, flow, action } = props;

  const setBuyingType = (processType, buyingType = null) => {
    if (processType === constants.BUYING_PROCESS_TYPE_BUYING) {
      // hawakomEvent(buyingType);
      action('buyingOptions', buyingType);
    } else {
      // hawakomEvent(constants.BUYING_PROCESS_TYPE_SWITCH_PLAN)
    }
  };

  ////////////////////////////////
  const redirectToSwitchPlan = () => {
    let switchPlan = urlFormatter(
      links['informative-offers-hawakom-switch_plan']['route']
    );
    let switchPlanWithoutKey = switchPlan.split(':planSlug');
    let packageInfoStateSlug = null;

    if (history.location.state && history.location.state.packageInfo) {
      packageInfoStateSlug = history.location.state.packageInfo.slug;
    } else {
      packageInfoStateSlug = urlState.packageInfo.slug;
    }

    updateRedirect(
      <Redirect
        to={{
          pathname: switchPlanWithoutKey[0] + packageInfoStateSlug,
        }}
        push={true}
      />
    );
  };

  ////////////////////////////////

  let content = null;

  let orderSimLink = null;
  let orderESimLink = null;
  let bringNumberLink = null;
  let registerSimLink = null;
  let onlineRechargeSimLink = null;

  switch (flow) {
    case constants.SHOP_BOX_FLOW_HAWAKOM:
    case constants.SHOP_BOX_FLOW_SEC:
      content = (
        <div className="shopBoxesWrapper">
          <div className="shopBox">
            <img
              src={shopboxPlaceholder}
              className="orderSimShopBox"
              alt=""
              onClick={() => {
                setBuyingType(
                  constants.BUYING_PROCESS_TYPE_BUYING,
                  constants.SIM_TYPE_SIM
                );
              }}
            />
          </div>
          <div className="shopBox">
            <img
              src={shopboxPlaceholder}
              className="orderESimIconShopBox"
              alt=""
              onClick={() => {
                setBuyingType(
                  constants.BUYING_PROCESS_TYPE_BUYING,
                  constants.SIM_TYPE_ESIM
                );
              }}
            />
          </div>
          <div className="shopBox">
            <img
              src={shopboxPlaceholder}
              className="switchPlanIconShopBox"
              alt=""
              onClick={() => {
                setBuyingType(
                  constants.BUYING_PROCESS_TYPE_SWITCH_PLAN,
                  constants.BUYING_PROCESS_TYPE_SWITCH_PLAN
                );
                redirectToSwitchPlan();
              }}
            />
          </div>
        </div>
      );

      break;
    case constants.SHOP_BOX_FLOW_NASSR:
      content = (
        <div className="shopBoxesWrapper">
          <div className="shopBox">
            <img
              src={shopboxPlaceholder}
              className="orderSimShopBox"
              alt=""
              onClick={() => {
                action('buyingOptions', constants.SIM_TYPE_SIM);
              }}
            />
          </div>
          <div className="shopBox">
            <img
              src={shopboxPlaceholder}
              className="orderESimIconShopBox"
              alt=""
              onClick={() => {
                action('buyingOptions', constants.SIM_TYPE_ESIM);
              }}
            />
          </div>
        </div>
      );
      break;
    case constants.ORDER_SIM_STEP_REFERAL:
      orderSimLink = orderESimLink = urlFormatter(
        links['shop-buying_number_type']['route']
      );
      // const queryParam = getQueries('bp_e');
      const queryParam = null;
      let orderSimObj = orderSimLink;
      let orderESimObj = orderESimLink;

      if (queryParam) {
        orderSimObj = {
          pathname: orderSimLink,
          state: {
            referral: queryParam,
            esimFlow: false,
          },
        };

        orderESimObj = {
          pathname: orderESimLink,
          state: {
            referral: queryParam,
            esimFlow: true,
          },
        };
      }
      content = (
        <div className="shopBoxesWrapper">
          <div className="shopBox">
            <Link to={orderSimObj}>
              <div>
                <img
                  src={shopboxPlaceholder}
                  className="orderSimShopBox"
                  alt=""
                />
              </div>
            </Link>
          </div>
          <div className="shopBox">
            <Link to={orderESimObj}>
              <div>
                <img
                  src={shopboxPlaceholder}
                  className="orderESimIconShopBox"
                  alt=""
                />
              </div>
            </Link>
          </div>
        </div>
      );
      break;
    case constants.SHOP_BOX_FLOW_NEW_CUSTOMER:
      orderSimLink = urlFormatter(links['shop-join_lebara']['route']);
      orderESimLink = urlFormatter(
        links['shop-join_lebara-voice_plans']['route']
      );
      content = (
        <div className="shopBoxesWrapper">
          <div className="shopBox">
            <Link to={orderSimLink}>
              <div>
                <img
                  src={shopboxPlaceholder}
                  className="orderSimShopBox"
                  alt=""
                />
              </div>
            </Link>
          </div>
          <div className="shopBox">
            <Link to={orderESimLink}>
              <div>
                <img
                  src={shopboxPlaceholder}
                  className="orderESimIconShopBox"
                  alt=""
                />
              </div>
            </Link>
          </div>
        </div>
      );
      break;
    default: // come from shop page
      orderSimLink = urlFormatter(
        links['shop-number_booking-initialredirect']['route']
      );
      bringNumberLink = urlFormatter(
        links['shop-join_lebara-bring_number']['route']
      );

      registerSimLink = urlFormatter(
        links['informative-register_sim']['route']
      );
      onlineRechargeSimLink = urlFormatter(
        links['informative-online_recharge']['route']
      );

      content = (
        <div className="shopBoxesWrapper">
          <div className="shopBox">
            <Link to={orderSimLink}>
              <img
                src={shopboxPlaceholder}
                className="orderSimShopBox"
                alt=""
              />
            </Link>
          </div>
          <div className="shopBox">
            <Link to={bringNumberLink}>
              <img src={shopboxPlaceholder} className="mnpIconShopBox" alt="" />
            </Link>
          </div>
          <div className="shopBox">
            <Link to={registerSimLink}>
              <img
                src={shopboxPlaceholder}
                className="registerSimIconShopBox"
                alt=""
              />
            </Link>
          </div>
          <div className="shopBox">
            <Link to={onlineRechargeSimLink}>
              <img
                src={shopboxPlaceholder}
                className="onlineRechargeIconShopBox"
                alt=""
              />
            </Link>
          </div>
        </div>
      );
  }

  if (
    flow !== constants.SHOP_BOX_FLOW_NEW_CUSTOMER &&
    flow !== constants.SHOP_BOX_FLOW_SHOP &&
    flow !== constants.SHOP_BOX_FLOW_REFERAL &&
    (!location.state || !location.state.packageInfo) &&
    (!urlState || !urlState.packageInfo) &&
    !forceRedirect
  ) {
    let packgeCategory = urlFormatter(
      links['informative-offers-packages_hub']['route']
    );
    let packgeCategoryWithoutKey = packgeCategory.split(':categoryId');

    forceRedirect = true;
    updateRedirect(
      <Redirect
        to={{
          pathname:
            packgeCategoryWithoutKey[0] + location.pathname.split('/')[2],
        }}
        push={true}
      />
    );
  }

  return (
    <>
      {redirect}
      {content}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    links: state.layout.routes,
    lang: state.layout.iso,
    urlState: state.layout.urlState,
  };
};

export default connect(mapStateToProps, null)(withRouter(ShopBoxes));
